import config from './config';
const TOKEN_KEY = 'token';
const UID_KEY = 'uid';
const INFO_KEY= 'info';
const NAME_KEY = 'username';

const getToken = function() {
  //从配置文件中读取token 若没写入 则从storage中取并写入配置
  let token = config.token;
  if(!token) {
    console.log('Read token from storage.');
    token = getStorage(TOKEN_KEY);
    config.token = token;
  }
  //判断token是否过期 过期返回null
  if(token && Date.now() - token.timestamp > 12 * 60 * 60 * 1000 - 60000) {
    token = null;
  }
  return token;
};

const getUserId = function () {
  return config.uid || localStorage.getItem(UID_KEY) || null;
}

const getUserName = function () {
  return config.username || localStorage.getItem(NAME_KEY) || null;
}
const getStorageInfo = function() {
    let info = config[INFO_KEY];
    if(!info) {
      console.log('Read token from storage.');
      info = getStorage(INFO_KEY);
      config[INFO_KEY] = info;
    }
    return info;
}

const setToken = function(res) {
  let temp = {
    timestamp: Date.now(),
    token: res.token
  };
  const admin = res.data;
  config[TOKEN_KEY] = temp;
  config[NAME_KEY] = admin ? admin.name : (res.username || '管理员');
  config[INFO_KEY] = admin;
  config[UID_KEY] = res.id;
  let value = JSON.stringify(temp);
  localStorage.setItem(TOKEN_KEY, value);
  localStorage.setItem(NAME_KEY, config.username);
  admin && localStorage.setItem(INFO_KEY, JSON.stringify(admin));
  localStorage.setItem(UID_KEY, config.uid);
};

const getStorage = function(key) {
  let result = null;
  let storage = localStorage.getItem(key);
  try {
    storage = JSON.parse(storage);
    result = storage;
  } catch (e) {
    console.log(`Storage for ${key} parse failed.`);
  }
  return result;
};

const cleanToken = function() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(NAME_KEY);
  localStorage.removeItem(INFO_KEY);
  localStorage.removeItem(UID_KEY);
  config.token = null;
  config.info = null;
  config.uid = null;
};

export { getToken, getUserId, getUserName, getStorage, setToken, cleanToken, getStorageInfo }
